module.exports = __webpack_public_path__ + "assets/img/budapark3-320.7ad2dc69.webp";